import { StylesConfig } from 'react-select';

import { Maybe } from '../../../../graphql.schema';

export type LevelOptionType = {
  value: Maybe<string> | undefined;
  label: Maybe<string> | undefined;
  level?: Maybe<string> | undefined;
  levelDescription?: Maybe<string> | undefined;
};

export const customStyles: StylesConfig<LevelOptionType, true> = {
  container: (base: Record<string, unknown>) => ({
    ...base,
    borderRadius: '0',
  }),
  control: (base: Record<string, unknown>) => ({
    ...base,
    borderRadius: '0',
    borderColor: '#fff',
    cursor: 'pointer',
  }),
  option: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: '#fff',
    cursor: 'pointer',
    padding: '4px 12px',
    fontSize: '22px',
    fontWeight: 800,
    color: '#003359',
    '&:hover': {
      backgroundColor: '#003359',
      color: '#fff',
    },
  }),
  menuList: (base: Record<string, unknown>) => ({
    ...base,
    padding: 0,
  }),
  menu: (base: Record<string, unknown>) => ({
    ...base,
    borderRadius: 0,
  }),
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    color: '#fff',
    backgroundColor: '#003359',
    padding: '5px 12px',
  }),
  singleValue: (base: Record<string, unknown>) => ({
    ...base,
    color: '#fff',
    backgroundColor: '#003359',
    fontWeight: 800,
    fontSize: '27px',
  }),
  dropdownIndicator: (base: Record<string, unknown>) => ({
    ...base,
    color: '#fff',
    padding: '5px 12px',
    backgroundColor: '#003359',
  }),
  indicatorsContainer: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: '#003359',
  }),
};
